import { GridColumns, GridValueGetterParams } from '@mui/x-data-grid-pro';
import { InstrumentoFinanceiroApiResponse } from 'common/genericTypes';
import { formatEightDecimalsCurrency } from 'utils/number';

export const getInadimplenciaColumns = (): GridColumns => [
  {
    field: 'codigo',
    headerName: 'Código do Instrumento',
    valueGetter: (params: GridValueGetterParams<InstrumentoFinanceiroApiResponse>) =>
      params.row.codigo,
    minWidth: 200,
    flex: 1,
    resizable: true,
  },
  {
    field: 'tipoInstrumentoFinanceiro',
    headerName: 'Tipo de Instrumento',
    valueGetter: (params: GridValueGetterParams<InstrumentoFinanceiroApiResponse>) => params.row.tipoInstrumentoFinanceiro,
    minWidth: 200,
    flex: 1,
    resizable: true,
  },
  {
    field: 'emissor',
    headerName: 'Emissor',
    valueGetter: (params: GridValueGetterParams<InstrumentoFinanceiroApiResponse>) => params.row.razaoSocialEmissor,
    minWidth: 200,
    flex: 1,
    resizable: true,
  },
  {
    field: 'dataEmissao',
    headerName: 'Data da Emissão',
    valueGetter: (params: GridValueGetterParams<InstrumentoFinanceiroApiResponse>) => {
      const dataCriacao = new Date(params.row.criteriosRemuneracao.dataEmissao);
      return !isNaN(dataCriacao.getTime()) ? dataCriacao.toLocaleDateString() : 'Data inválida';
    },
    minWidth: 150,
    flex: 0.8,
    resizable: true,
  },
  {
    field: 'valorDeEmissao',
    headerName: 'Valor de Emissão',
    valueGetter: (params: GridValueGetterParams<InstrumentoFinanceiroApiResponse>) => {
      const valor = params.row.criteriosRemuneracao.valorNominalUnitarioEmissao;
      if (typeof valor === 'number') {
        return formatEightDecimalsCurrency(valor);
      }
      return 'Valor inválido';
    },
    minWidth: 100,
    width: 100,
    flex: 1,
    resizable: true,
  },
  {
    field: 'situacao',
    headerName: 'Situação',
    valueGetter: (params: GridValueGetterParams<InstrumentoFinanceiroApiResponse>) => {
      return params.row.hasPagamentosInadimplentes ? 'Inadimplente' : 'Adimplente';
    },
    minWidth: 200,
    flex: 1,
    resizable: true,
  }
];
